function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "18"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_1160",
  "data-name": "Path 1160",
  d: "M13 10h5l-6 6-6-6h5V3h2zm-9 9h16v-7h2v8a1 1 0 01-1 1H3a1 1 0 01-1-1v-8h2z",
  transform: "translate(-2 -3)",
  fill: "#fff"
})));